import { shallowEqual, useSelector } from 'react-redux'
const selectore = (state) => state.extra_resource_book;

export const useExtraResourceEbook = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}